var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,22.5L6.1,22.5z M26.7,40c0.7,0,1.3-0.3,1.7-0.8c0.5-0.5,0.7-1.1,0.7-1.8c0-0.7-0.2-1.3-0.7-1.8c-0.5-0.5-1.1-0.7-1.8-0.7c-1.4,0.1-2.4,1.2-2.4,2.6C24.4,38.9,25.4,40,26.7,40L26.7,40z M39.5,19c0.7,0,1.3-0.3,1.7-0.8c0.5-0.5,0.7-1.1,0.7-1.8c0-0.7-0.2-1.3-0.7-1.8c-1-1-2.5-0.9-3.5,0s-1,2.5,0,3.5C38.2,18.7,38.8,19,39.5,19L39.5,19z M11.4,18h9.9v-3h-9.9C11.4,15,11.4,18,11.4,18z M11.4,27h9.9v-3h-9.9C11.4,24,11.4,27,11.4,27z M6.1,37c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1V8c0-0.8,0.3-1.6,0.9-2.1C4.5,5.3,5.3,5,6.1,5h34.3c0.8,0,1.5,0.3,2.1,0.9C43,6.4,43.3,7.2,43.3,8H6.1v26h12.2v3L6.1,37L6.1,37z M26.7,43c-1.5,0-2.8-0.6-3.8-1.6c-2.1-2.2-2.1-5.7,0.1-7.8c0.6-0.6,1.4-1.1,2.3-1.4v-6.7H38v-3.7c-2.3-0.7-4-2.8-4-5.3c0-1.5,0.6-2.9,1.6-3.9c2.1-2.1,5.5-2.1,7.6-0.1c0,0,0,0,0.1,0.1c1.9,2,2.1,5,0.5,7.2c-0.7,0.9-1.7,1.6-2.8,2v6.7H28.1v3.7c2.9,0.9,4.6,4,3.7,6.9c-0.3,0.8-0.7,1.6-1.3,2.2C29.5,42.5,28.1,43,26.7,43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.3143bc68636b5e97d16daaa2b257170c.svg";
export { ForwardRef as ReactComponent };